import { render } from "./Footer.vue?vue&type=template&id=4421d826&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4421d826&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=4421d826&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4421d826"]])

export default __exports__